<template>
  <div v-if="!isMobileScreen" class="signup">
    <div class="signup__letfside bg-primary-opacity">
      <onboarding />
    </div>
    <div class="signup__rightside">
      <sign-up-form />
      <helpdesk />
    </div>
  </div>
  <div
    v-else-if="isMobileScreen && onboarding"
    class="signup bg-primary-opacity"
  >
    <div class="signup__mobile--wrapper">
      <onboarding />
      <vs-button @click="finishOnboarding">Fazer Cadastro</vs-button>
      <p>
        Já tem uma conta?
        <vs-button type="flat" class="p-0" @click="handleRedirectToSignIn">
          Fazer login
        </vs-button>
      </p>
    </div>
  </div>
  <div v-else class="signup">
    <div class="signup__mobile--wrapper">
      <sign-up-form />
      <helpdesk />
    </div>
  </div>
</template>

<script>
import Onboarding from "@/components/onboarding/Onboarding.vue";
import SignUpForm from "@/components/form/SignUpForm.vue";
import Helpdesk from "@/components/helpdesk/Helpdesk.vue";  

import { get } from "lodash";

export default {
  components: { Onboarding, SignUpForm, Helpdesk },
  data: () => ({
    onboarding: true,
    isMobileScreen: false,
  }),
  methods: {
    finishOnboarding() {
      this.onboarding = false;
    },
    handleRedirectToSignIn() {
      const { query, params } = this.$router.history.current;

      this.$router.push({
        name: "signin",
        params,
        query,
      });
    },
    setIsMobileScreen() {
      this.isMobileScreen = window.innerWidth < 768;
    },
    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/signup`)
        : this.$ga.page(`${company_label}/signup`);
    },
  },
  async beforeRouteEnter(to, from, next) {
    if (to.params.company_label === undefined)
      next({
        name: "notfound",
      });
    next();
  },
  created() {
    this.setIsMobileScreen();

    const label = get(this.$router, 'history.current.params.company_label', null);
    if (label === 'anonima') return;

    this.googleAnalytics();
  },
};
</script>

<style lang="scss" scoped>
.signup {
  display: flex;
  width: 100%;
  height: 100vh;

  &__letfside {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;
  }

  &__rightside {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    max-height: 100vh;
    min-width: 440px;
    padding: 0 40px;
  }

  &__mobile--wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 8px;
    align-self: center;
    justify-self: center;
  }

  &__mobile--wrapper > button {
    margin: 22px 13px;

    @media (max-width: 599px) {
      margin: 15px 13px;
    }
  }

  &__mobile--wrapper > p {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    text-align: center;
  }
}
</style>
